module.exports = __webpack_public_path__ + "img/1573.8af7b4da.gif";